<template>
  <div class="container-fluid h-100">
    <div class="content-register" id="content1-register">
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100"
      >
        <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12 padding-t2">
          <h1 class="club">REGÍSTRATE Y ÚNETE AL CLUB</h1>
        </div>
        <div class=" col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12  ">
          <div class="row p-row">
            <div class="col-12 small-info">
              <small
                >Recuerda que los datos marcados con (*) son obligatorios</small
              >
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3 ">
                  <select
                    v-model="form.documentType"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.documentType }"
                    id="exampleFormControlSelect1"
                    placeholder="Tipo de documento *"
                  >
                    <option value="0" disabled selected
                      >Tipo de documento
                    </option>
                    <option
                      v-for="(item, i) in listTypeDocuments"
                      :key="'td' + i"
                      :value="item.id"
                      class="color-option"
                      >{{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.documentType"
                  class="text-danger float-left small error-danger"
                  >{{ errors.documentType }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group  mb-3">
                  <input
                    v-model="form.documentNumber"
                    type="text"
                    class="form-control color-input"
                    :class="{ 'is-danger': errors.documentNumber }"
                    aria-label="document"
                    placeholder="Número de documento "
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.documentNumber"
                  class="text-danger float-left small error-danger"
                  >{{ errors.documentNumber }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.name }"
                    v-model="form.name"
                    type="text"
                    class="form-control color-input"
                    aria-label="name"
                    placeholder="Nombres *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.name"
                  class="text-danger float-left small error-danger"
                  >{{ errors.name }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.lastName }"
                    v-model="form.lastName"
                    type="text"
                    class="form-control color-input"
                    aria-label="lastName"
                    placeholder="Apellidos *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.lastName"
                  class="text-danger float-left small error-danger"
                  >{{ errors.lastName }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.phone }"
                    type="text"
                    v-model="form.phone"
                    class="form-control color-input"
                    aria-label="phone"
                    placeholder="Teléfono *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.phone"
                  class="text-danger float-left small error-danger"
                  >{{ errors.phone }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.email }"
                    v-model="form.email"
                    type="text"
                    class="form-control color-input"
                    aria-label="email"
                    placeholder="Email *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.email"
                  class="text-danger float-left small error-danger"
                  >{{ errors.email }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.plate }"
                    v-model="form.plate"
                    type="text"
                    class="form-control color-input"
                    aria-label="plate"
                    placeholder="Placa"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.plate"
                  class="text-danger float-left small error-danger"
                  >{{ errors.plate }}</span
                >
              </div>
            </div>
            <div
              class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12"
              v-if="companyId != 1"
            >
              <div class="form-group">
                <div class="input-group mb-3 ">
                  <select
                    v-model="form.dateRange"
                    class="form-control color-input select-input"
                    id="exampleFormControlSelect1"
                    placeholder="Seleccione una fecha para recoger el kit *"
                  >
                    <option value="0" disabled selected
                      >Seleccione una fecha para recoger el kit *</option
                    >
                    <option
                      v-for="(item, i) in listDateRange"
                      :key="'td' + i"
                      :value="item.id"
                      class="color-option"
                    >
                      {{ item.range }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <template v-else>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group">
                  <div class="input-group  mb-3">
                    <select
                      v-model="form.statesId"
                      class="form-control color-input select-input"
                      :class="{ 'is-danger': errors.statesId }"
                      id="exampleFormControlSelect1"
                    >
                      <option disabled value="0" selected
                        >Departamento *</option
                      >
                      <option
                        v-for="(item, i) in listDocuments"
                        :value="item.id"
                        class=" color-option"
                        :key="'st' + i"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <span
                    v-if="errors.statesId"
                    class="text-danger float-left small error-danger"
                    >{{ errors.statesId }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group">
                  <div class="input-group mb-3">
                    <select
                      v-model="form.cityId"
                      :disabled="showCities"
                      class="form-control color-input select-input"
                      :class="{ 'is-danger': errors.cityId }"
                      id="exampleFormControlSelect1"
                    >
                      <option value="0" disabled selected>Ciudad *</option>
                      <option
                        v-for="(item, i) in listCities"
                        :key="'ci' + i"
                        :value="item.id"
                        class=" color-option"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <span
                    v-if="errors.cityId"
                    class="text-danger float-left small error-danger"
                    >{{ errors.cityId }}</span
                  >
                </div>
              </div>
            </template>

            <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
              <button
                :disabled="disableLoading"
                type="button"
                @click="saveUser()"
                class="btn btn-danger btn-sm btn-block btn-register-company"
                id="btn-register-company-id"
              >
                <span
                  v-if="disableLoading"
                  class="spinner-border spinner-border-md"
                  role="status"
                  aria-hidden="true"
                ></span>
                <template v-else>REGÍSTRATE</template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "contentLanding",
  data() {
    return {
      listDocuments: [],
      listCities: [],
      listTypeDocuments: [],
      listDateRange: [],
      form: {
        documentType: 0,
        documentNumber: "",
        name: "",
        lastName: "",
        plate: "",
        phone: "",
        email: "",
        check: true,
        dateRange: 0,
        statesId: 0,
        cityId: 0
      },
      listCompanies: [],
      errors: {
        documentType: false,
        documentNumber: false,
        name: false,
        lastName: false,
        plate: false,
        phone: false,
        email: false,
        dateRange: 0,
        check: false,
        statesId: 0,
        cityId: 0
      },
      showCities: true,
      disableLoading: false,
      companyId: 0
    };
  },
  watch: {
    "form.documentType": function(n) {
      if (n) {
        this.errors.documentType = false;
      } else {
        this.errors.documentType = "El tipo de documento es requerido.";
      }
    },
    "form.documentNumber": function(n) {
      if (n) {
        this.errors.documentNumber = false;
      } else {
        this.errors.documentNumber = "El tipo de documento es requerido.";
      }
    },
    "form.name": function(n) {
      if (n) {
        this.errors.name = false;
      } else {
        this.errors.name = "Los nombres son requeridos.";
      }
    },
    "form.lastName": function(n) {
      if (n) {
        this.errors.lastName = false;
      } else {
        this.errors.lastName = "Los apellido son requeridos.";
      }
    },
    "form.phone": function(n) {
      if (!n) {
        this.errors.phone = "El teléfono es requerido.";
      } else if (!this.validPhone(n)) {
        this.errors.phone = "El teléfono es inválido.";
      } else {
        this.errors.phone = false;
      }
    },
    "form.plate": function(n) {
      if (n == "") {
        this.errors.plate = false;
      } else if (!this.validPlate(n)) {
        this.errors.plate =
          "La placa es incorrecta debe tener 3 letras, 2 números y una letra si es moto o un número si es automóvil.";
      } else {
        this.errors.plate = false;
      }
    },
    "form.email": function(n) {
      if (!n) {
        this.errors.email = "El email es requerido.";
      } else if (!this.validEmail(n)) {
        this.errors.email = "El email es inválido.";
      } else {
        this.errors.email = false;
      }
    },
    "form.check": function() {
      if (!this.form.check) {
        this.errors.check = "Debe aceptar términos y condiciones";
      } else {
        this.errors.check = false;
      }
    },
    // "form.dateRange": function () {
    //   if (!this.form.dateRange) {
    //     this.errors.dateRange =
    //       "El rango de fecha para reclaramar el kit es requerido";
    //   } else {
    //     this.errors.dateRange = false;
    //   }
    // },
    "form.statesId": function(n) {
      this.getCities(n);
      if (n == 0) {
        this.errors.state = "El departamento es requerido.";
      } else {
        this.errors.state = false;
      }
    },
    "form.cityId": function(n) {
      if (n != 0) {
        this.errors.cityId = false;
      } else {
        this.errors.cityId = "La ciudad es requerida.";
      }
    }
  },
  methods: {
    irCode() {
      let sesion = sessionStorage.getItem("token");
      if (sesion == "" || sesion == null) {
        this.$router.push({ name: "login" });
      } else {
        this.$router.push({ name: "homeUser" });
      }
    },
    getListStates() {
      var app = this;
      axios
        .get("api/getStates")
        .then(function(res) {
          app.listDocuments = res.data.states;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCompany() {
      var app = this;
      axios
        .get()
        .then(function(res) {
          app.listCompanies = res.data;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCities(stateId) {
      var app = this;
      var data = {
        stateId: stateId
      };
      axios
        .post("api/showCity", data)
        .then(function(res) {
          app.showCities = false;
          app.listCities = res.data.cities;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getTypeDocuments() {
      var app = this;
      axios
        .get("api/documentTypeController")
        .then(function(res) {
          app.listTypeDocuments = res.data.TypeDocument;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    saveUser() {
      if (this.validform()) {
        this.disableLoading = true;
        var app = this;
        this.form.companyId = this.companyId;
        console.log(this.form);
        axios
          .post("api/companies/user/register", this.form, {
            responseType: "arraybuffer"
          })
          .then(function(res) {
            console.log(res);
            app
              .$swal({
                title: "Registro exitoso",
                text: "Gracias por participar.",
                icon: "success",
                showCancelButton: false,
                confirmButtonColor: "#dc3545",
                confirmButtonText: "Descarga aquí tu bono"
              })
              .then(result => {
                if (result.value) {
                  console.log(res.data);
                  app.descargar(res.data);
                  app.$swal({
                    text: "Su descarga iniciará en un momento.",
                    icon: "success"
                  });
                }
              });
          })
          .catch(function(error) {
            console.log(error);
            app.disableLoading = false;
            app.$swal({
              icon: "error",
              title: "Oops...",
              text:
                "Error al registrar la información, por favor intentelo en un momento."
            });
          });
      }
    },
    descargar(data) {
      const file = new Blob([data], { type: "application/pdf;charset=utf-8;" });
      const fileURL = URL.createObjectURL(file);
      console.log(fileURL);
      const link = document.createElement("a");
      link.href = fileURL;
      link.download =
        "Bono-Havoline-" + new Date().toISOString().substr(0, 10) + ".pdf";
      link.click();
      this.disableLoading = false;
    },
    validform() {
      let app = this;
      if (app.form.documentNumber && !app.form.documentType) {
        app.errors.documentType = "El tipo de documento es requerido";
      }

      if (app.form.documentType && !app.form.documentNumber) {
        app.errors.documentNumber = "El número de documento es requerido";
      }

      if (!app.form.name) {
        app.errors.name = "Los nombres son requeridos.";
      }

      if (!app.form.lastName) {
        app.errors.lastName = "Los apellidos son requeridos.";
      }

      if (!app.form.phone) {
        app.errors.phone = "El número de teléfono es requerido.";
      }

      if (!app.form.email) {
        app.errors.email = "El email es requerido.";
      }

      if (!app.form.check) {
        app.errors.check = "Debe aceptar términos y condiciones";
      }
      if (
        !app.errors.documentType &&
        !app.errors.documentNumber &&
        !app.errors.name &&
        !app.errors.lastName &&
        !app.errors.phone &&
        !app.errors.email &&
        !app.errors.check &&
        !app.validEmail(app.errors.email) &&
        !app.validPhone(app.errors.phone) &&
        !app.validPlate(app.errors.plate)
      ) {
        return true;
      }

      return false;
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone(phone) {
      var re = /^[0-9]{7,10}$/;
      return re.test(phone);
    },
    validPlate(plate) {
      var re = /^([a-zA-Z]{3})+([0-9]{2})+([0-9a-zA-Z]{0,1})$/;
      return re.test(plate);
    },
    validPassword(password) {
      var re = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
      return re.test(password);
    },
    validateCompany() {
      var company = this.$route.params.company;
      console.log(company);
      switch (company) {
        case "rappi":
          this.companyId = 1; // rappi equivale a 1 en bd
          this.getDateRange(this.companyId);
          break;
        case "ubereats":
          this.companyId = 2; // ubereats equivale a 2 en bd
          this.getDateRange(this.companyId);
          break;
        case "domicilios":
          this.companyId = 3; // domicilios equivale a 3 en bd
          this.getDateRange(this.companyId);
          break;
        default:
          this.$router.push({ name: "404" });
          break;
      }
    },
    getDateRange(id) {
      var app = this;
      axios
        .get("/api/companies/range_dates/" + id)
        .then(function(res) {
          console.log(res);
          if (res.data.cod == 0) {
            app.listDateRange = res.data.message;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  mounted() {
    this.getListStates();
    this.getTypeDocuments();
    this.validateCompany();
  }
};
</script>
<style scope>
.content-register {
  padding-left: 5%;
  padding-top: 14%;
  padding-bottom: 13%;
  height: 100%;
}

.club {
  font-size: 60px;
  font-family: "Gotham-UltraItalic";
  text-align: left;
}

.ingresa {
  font-size: 18px;
  text-align: left;
  font-family: "GothamBookItalic";
}

.t-c {
  text-align: center;
}

#content1-register {
  background-size: cover;
  background-image: url("../../assets/img/03.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}

.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}

.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}

a.condiciones {
  cursor: pointer !important;
  color: white;
  border-bottom: 1px solid;
}

.condiciones:hover {
  color: #b3b3b3 !important;
  /* border-bottom: 1px solid; */
}

.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}

.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}

.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}

.error-danger {
  text-align: left !important;
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}

.color-input::placeholder {
  color: white !important;
}

.color-option {
  color: black !important;
}

.color-option:active {
  background-color: crimson !important;
}

.icon-disable {
  color: #676565 !important;
}

.input-code:disabled {
  opacity: 0 !important;
  border-color: #000000 !important;
}

.small-info {
  text-align: left !important;
  color: #fff !important;
  font-size: 16px !important;
}

.icon::before {
  position: absolute;
  top: 25%;
  left: 5%;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}

@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}

@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP NORMAL */

@media (max-width: 1200px) {
  .content-register {
    height: 100%;
  }
}

/* TABLET */

@media (max-width: 1023px) {
  .content-register {
    height: 100%;
  }

  .padding-t2 {
    padding-top: 13%;
    padding-bottom: 8%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .p-row {
    padding-bottom: 1% !important;
  }

  .content-register {
    padding-left: 0%;
    padding-top: 50%;
    padding-bottom: 30%;
  }

  .club {
    font-size: 40px;
    text-align: left;
  }

  .ingresa {
    font-size: 18px;
    text-align: left;
  }

  .margin-btn {
    margin-bottom: 35%;
  }
}
</style>
